import { render, staticRenderFns } from "./CombinedInvoice.vue?vue&type=template&id=6122b5a1&"
import script from "./CombinedInvoice.vue?vue&type=script&lang=js&"
export * from "./CombinedInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports